/*
 * Artist contact details and social links, used by the follow icons
 * (bottom right) and the Contact page. Edit them here only.
 * `color` is the platform's brand color: icons turn that color on hover.
 */

// The artist the site belongs to: the follow icons and Contact are this
// artist's, whoever else is credited on a song (songs.js has each song's own
// `artist`, e.g. with a featuring)
export const ARTIST_NAME = "thangcao";

// Email shown on the Contact page. Leave empty ("") to hide the email line.
export const CONTACT_EMAIL = "thangcao.contact@gmail.com";

export const ARTIST_LINKS = [
  {
    key: "facebook",
    color: "#1877F2", // brand color, shown on hover
    name: "Facebook",
    handle: "by.thangcao",
    href: "https://www.facebook.com/by.thangcao",
  },
  {
    key: "instagram",
    color: "#E4405F", // brand color, shown on hover
    name: "Instagram",
    handle: "@by.thangcao",
    href: "https://www.instagram.com/by.thangcao/",
  },
  {
    key: "threads",
    color: "#FFFFFF",
    // Black-and-white brand: instead of changing color, it glows on hover
    glow: true,
    name: "Threads",
    handle: "@by.thangcao",
    href: "https://www.threads.com/@by.thangcao",
  },
  {
    key: "tiktok",
    color: "#FE2C55", // brand color, shown on hover
    name: "TikTok",
    handle: "@by.thangcao",
    href: "https://www.tiktok.com/@by.thangcao",
  },
  {
    key: "youtube",
    color: "#FF0000", // brand color, shown on hover
    name: "YouTube",
    handle: "@thangcao",
    href: "https://www.youtube.com/@thangcao",
  },
  {
    key: "spotify",
    color: "#1DB954", // brand color, shown on hover
    name: "Spotify",
    handle: "thangcao",
    href: "https://open.spotify.com/artist/5j4IjOrWvqn9RKZsg0hEQR",
  },
  {
    key: "soundcloud",
    color: "#FF5500", // brand color, shown on hover
    name: "SoundCloud",
    handle: "bythangcao",
    href: "https://soundcloud.com/bythangcao",
  },
];
